import React from 'react';

import { Row, Col } from 'react-bootstrap';

import { ControlPageBlock, InputField } from '../blocks/edit_blocks';
import Fetcher from '../common/communicate';
import { PROJECT_PREFIX } from '../const';

export default class AdminUserAddScreen extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: {
                username: '',
                first_name: '',
                last_name: '',
                is_staff: true,
                password: Math.random().toString(36),
            },
            not_valid: {},
            loading: true,

        };
        this.handleChange = this.handleChange.bind(this);
        this.sendData = this.sendData.bind(this);
        this.removeData = this.removeData.bind(this);
        this.goToPreviousPage = this.goToPreviousPage.bind(this);
        this.handleData = this.handleData.bind(this);
        this.API_ENDPOINT = 'admin/users/';
    }

    handleData(data) {
        this.setState({ loading: false, data });
    }

    sendData(event) {
        this.validate();

        const request_method = 'POST';
        const save_type = event.currentTarget.id;

        let callback = this.handleData;

        if (save_type === 'save_button') {
            callback = this.goToPreviousPage;
        }

        Fetcher(this.API_ENDPOINT, request_method, callback, this.state.data);
    }

    goToPreviousPage() {
        this.props.history.push(`${PROJECT_PREFIX}/admin/users`);
    }

    removeData() {
        Fetcher(this.API_ENDPOINT, 'DELETE', this.goToPreviousPage);
    }

    handleChange(event) {
        const state = event.currentTarget.value;
        const new_state = this.state;
        new_state.data[event.currentTarget.id] = state;
        this.setState(new_state);
    }

    validate() {
        const no_valid_fields = {};
        const req_fields = ['email', 'nick'];

        for (let i = 0; i < Object.keys(req_fields).length; i++) {
            if (!this.state.data[req_fields[i]]) {
                no_valid_fields[req_fields[i]] = true;
            }
        }

        this.setState({ not_valid: Object.assign(this.state.not_valid, no_valid_fields) });
    }

    render() {
        return (
            <div>
                <div className="container">
                    <Row className="show-grid">
                        <Col md={12}>
                            <h3>
                                Пользователь:
                                {this.state.data.nick}
                            </h3>
                        </Col>
                    </Row>
                    <Row className="show-grid">
                        <Col md={8}>
                            <InputField
                                name="username"
                                label="E-mail"
                                value={this.state.data.username}
                                onChange={this.handleChange}
                                required
                                is_not_valid={this.state.not_valid.username || false}
                            />
                        </Col>
                    </Row>
                    <Row className="show-grid">
                        <Col md={8}>
                            <InputField
                                name="first_name"
                                label="Имя"
                                value={this.state.data.first_name}
                                onChange={this.handleChange}
                                required
                                is_not_valid={this.state.not_valid.first_name || false}
                            />
                        </Col>
                    </Row>
                    <Row className="show-grid">
                        <Col md={8}>
                            <InputField
                                name="last_name"
                                label="Фамилия"
                                value={this.state.data.last_name}
                                onChange={this.handleChange}
                                required
                                is_not_valid={this.state.not_valid.first_name || false}
                            />
                        </Col>
                    </Row>
                </div>
                <div className="container-fluid">
                    <ControlPageBlock
                        onSave={this.sendData}
                        onCancel={this.goToPreviousPage}
                    />
                </div>
            </div>
        );
    }
}
